import { Directive, inject } from "@angular/core";
import { DatePipe } from "@angular/common";

@Directive()
export class BudgetFormDirective {
  protected datePipe: DatePipe = inject(DatePipe);
}
